import { Immutable } from "immer";
import React from "react";
import { Link } from "tsi-common-react/src/components/Link/index";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { IMenuPageLink } from "../../utils/menu.interface";

import siteNavStyles from "../../styles/composable/site-nav.module.scss";
import styles from "./index.module.scss";

type IProps = Immutable<{
    linkObject: IMenuPageLink;
    isMobile: boolean;
    linkID: number;
}>;

export const PageLink = (props: IProps) => {
    const linkClass = props.isMobile
        ? concatClassNames([
              styles.mainDropdownMenuMobile,
              styles.mainDropdownMenuMobileLink,
              `main-dropdown-menu__mobile--${props.linkObject.value.page.slug}`,
          ])
        : concatClassNames([
              siteNavStyles.siteNavMainMenuItem,
              siteNavStyles.siteNavMainMenuItemHoverState,
              `site-nav__main-menu-item--${props.linkObject.value.override_title
                  .replace(/\s+/g, "-")
                  .toLowerCase()}`,
          ]);

    return (
        <span key={props.linkID}>
            <Link
                title={props.linkObject.value.override_title}
                className={linkClass}
                href={props.linkObject.value.page.url}
                target="_top"
                rel="noreferrer"
            >
                {props.linkObject.value.override_title}
            </Link>
        </span>
    );
};
